<template>
  <transition name="slide">
    <div id="sidebarmenu" v-show="view">
      <div class="closebtn" @click="closeSidebar"><i class="fa fa-times"></i></div>
      <ul class="menu-categories">
        <li :key="category" @click="navigateScroll(category,true,key+1)" v-for="(content, category, key) in categories">{{ category }}</li>
      </ul>
      <div class="footer-sidebar">
        <p class="vigencia" v-show="vigencia">Vigencia<br>{{ vigencia }}</p>
      </div>
    </div>
  </transition>
</template>
<script>
/* eslint-disable */
export default {
  name: 'SidebarMenu',
  props: {
    view: Boolean,
    categories: {}
  },
  methods: {
    closeSidebar () {
      this.$emit('sideBarStatus')
    },
    navigateScroll (where,from,pos) {
      if(pos){
        dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Índice', // Especificar que hace referencia al Índice
        'action': 'Click', // Se registra la acción como un clic
        'tag': pos+'. '+where // A qué categoría le hizo clic y en qué posición se encontraba
        })
      }
      
      where = where.replace(/ /g, '-');
      where = where.replace(/á/g, 'a');
      where = where.replace(/é/g, 'e');
      where = where.replace(/í/g, 'i');
      where = where.replace(/ó/g, 'o');
      where = where.replace(/ú/g, 'u');
      where = where.replace(/Á/g, 'a');
      where = where.replace(/É/g, 'e');
      where = where.replace(/Í/g, 'i');
      where = where.replace(/Ó/g, 'o');
      where = where.replace(/Ú/g, 'u');
      where = where.replace(/ñ/g, 'n');
      where = where.replace(/Ñ/g, 'N');

      if (!this.$parent.isMobile){
        $('#container').animate({scrollLeft: this.$parent.indice[where]}, 1000)
      } else {
        location.hash = '#' + where
        setTimeout(function(){
        let obj = $('#category-'+where).find('img')[0]
        $(obj).attr('src',$(obj).attr('data-url'));
        },1000)
      }
      if(from){
        this.closeSidebar()
      }
    }
  },
  data () {
    return {
      msg: 'menu',
      vigencia: ''
    }
  },
  mounted () {
    let index_vigencia = document.getElementById('vigencia').value
    this.vigencia = index_vigencia
    if(window.location.hash) {
      // Fragment exists
      let hashTerm = location.hash.replace('#','')
      hashTerm = hashTerm.replace('-',' ')
      setTimeout(() => this.navigateScroll(hashTerm,false,false), 1000);
    }
    let obj = this
    window.onhashchange = function(){
      let hashTerm = location.hash.replace('#','')
      obj.navigateScroll(hashTerm,false)
    }
  }
}

</script>
<style>
  .menu-categories{ margin:0px;padding:0px;margin-top:50px;list-style:none;overflow:auto;height:65vh; }
  .menu-categories li{ color:#666;padding:12px 10px;padding-left:35px;text-align:left;cursor:pointer;font-size:1.250em;border-bottom:dashed thin #ccc }
  .closebtn{ position:absolute;color:#E0172F;right:15px;top:15px; font-size:2em;cursor:pointer;}
  #sidebarmenu{ position:fixed;z-index:102;background-color:#fff;width:70%;height:100vh;overflow:auto;border-right:solid thin #ccc; }
  .footer-sidebar{position:absolute;bottom:70px;padding-left:30px;text-align:left;}
  .footer-sidebar .sharing{font-size:2em;color:#E0172F;text-align:left;}
  .footer-sidebar .vigencia{margin-top:5px;text-align:left;}
  .slide-enter-active,
  .slide-leave-active
  {
    transition: transform 0.2s ease;
  }
  .slide-enter,
  .slide-leave-to {
    transform: translateX(-100%);
    transition: all 150ms ease-in 0s
  }
  @media only screen and (min-width: 1000px) {
    #sidebarmenu{width:25%;}
    .menu-categories li{ font-size:16px;padding:20px 20px;}
  }
  #sidebarmenu ::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 7px;
  background-color: rgba(0,0,0,.1);
  }
  #sidebarmenu ::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: #e0172f;
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }
</style>



// WEBPACK FOOTER //
// src/components/SidebarMenuComponent.vue